<template>
  <div class="welcome">
    <div class="headBox">
      <div class="head_title">资金提现流水(单位: 元)</div>
      <div class="money">
        <span class="card card_device">
          <div class="card_title">总金额</div>
          <ul v-if="statisticsInfo4.withdraw">
            <li>
              总计:
              <span>{{statisticsInfo4.withdraw.amountA0}}</span>
            </li>
            <li>
              昨日:
              <span>{{statisticsInfo4.withdraw.amountD2}}</span>
            </li>
            <li>
              今日:
              <span>{{statisticsInfo4.withdraw.amountD1}}</span>
            </li>
          </ul>
        </span>
        <span class="card card_wx">
          <div class="card_title">微信金额</div>
          <ul v-if="statisticsInfo4.withdraw">
            <li>
              总计:
              <span>{{statisticsInfo4.withdraw.amountWA0}}</span>
            </li>
            <li>
              昨日:
              <span>{{statisticsInfo4.withdraw.amountWD2}}</span>
            </li>
            <li>
              今日:
              <span>{{statisticsInfo4.withdraw.amountWD1}}</span>
            </li>
          </ul>
        </span>
        <span class="card card_zfb">
          <div class="card_title">银行卡(连连)</div>
          <ul v-if="statisticsInfo4.withdraw">
            <li>
              总计:
              <span>{{statisticsInfo4.withdraw.amountAA0}}</span>
            </li>
            <li>
              昨日:
              <span>{{statisticsInfo4.withdraw.amountAD2}}</span>
            </li>
            <li>
              今日:
              <span>{{statisticsInfo4.withdraw.amountAD1}}</span>
            </li>
          </ul>
        </span>
      </div>
    </div>
    <div class="bodyBox">
      <span class="card card_user">
        <div class="head_title">用户统计</div>
        <div class="showBox">
          <div class="proxy">
            <div class="proxy_title">代理数量</div>
            <ul v-if="statisticsInfo1.agent">
              <li>
                总计:
                <span>{{statisticsInfo1.agent.agentA0}}</span>
              </li>
              <li>
                昨日:
                <span>{{statisticsInfo1.agent.agentD2}}</span>
              </li>
              <li>
                今日:
                <span>{{statisticsInfo1.agent.agentD1}}</span>
              </li>
            </ul>
          </div>
          <div class="user">
            <div class="user_title">用户数量</div>
            <ul v-if="statisticsInfo1.user">
              <li>
                总计:
                <span>{{statisticsInfo1.user.userA0}}</span>
              </li>
              <li>
                昨日:
                <span>{{statisticsInfo1.user.userD2}}</span>
              </li>
              <li>
                今日:
                <span>{{statisticsInfo1.user.userD1}}</span>
              </li>
            </ul>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import { statistics1, statistics4 } from '@/API/welcome'
export default {
  name: 'statistics',
  data() {
    return {
      statisticsInfo1: {},
      statisticsInfo4: {}
    }
  },
  mounted() {
    this.getStatistics1()
    this.getStatistics4()
  },
  methods: {
    // 获取数据展示区域数据
    async getStatistics1() {
      const { data: res } = await statistics1()
      if (res.code !== 200) return this.$message.error(res.message)
      this.statisticsInfo1 = res.data
    },
    // 获取数据展示区域数据
    async getStatistics4() {
      const { data: res } = await statistics4()
      if (res.code !== 200) return this.$message.error(res.message)
      this.statisticsInfo4 = res.data
    }
  }
}
</script>

<style lang="less" scoped>
.welcome {
  min-width: 1080px;
  padding: 0 15px;
}
.headBox {
  margin-bottom: 40px;
  .head_title {
    font-size: 20px;
    font-weight: 700;
    line-height: 50px;
    color: #2a3948;
    &::before {
      content: '';
      display: inline-block;
      margin: 0 15px;
      width: 14px;
      height: 14px;
      background-color: #3e79d3;
      transform: rotate(45deg);
    }
  }
  .money {
    display: flex;
    justify-content: space-between;
    .card {
      display: flex;
      flex-direction: column;
      width: 32%;
      height: 158px;
      color: #fff;
      background-size: 100% 100% !important;
      .card_title {
        margin-left: 20px;
        font-size: 20px;
        line-height: 60px;
      }
      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        > li > span {
          margin-left: 10px;
          font-size: 20px;
          vertical-align: middle;
        }
      }
    }
    .card_device {
      background: url('../../assets/images/1.png') no-repeat;
    }
    .card_wx {
      background: url('../../assets/images/2.png') no-repeat;
    }
    .card_zfb {
      background: url('../../assets/images/3.png') no-repeat;
    }
  }
}

.bodyBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .card {
    box-sizing: border-box;
    padding: 0 15px;
    box-shadow: 0px 3px 18px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    .head_title {
      font-size: 20px;
      font-weight: 700;
      color: #2a3948;
      line-height: 50px;
      &::before {
        content: '';
        display: inline-block;
        margin: 0 15px;
        width: 14px;
        height: 14px;
        background-color: #3e79d3;
        transform: rotate(45deg);
      }
      &::after {
        content: '';
        display: block;
        height: 5px;
        background-color: #fbf8fb;
      }
    }
  }
  .card_user {
    width: 35%;
    .showBox {
      display: flex;
      justify-content: space-around;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 32px;
        width: 2px;
        height: 122px;
        background-color: #e7f1ff;
      }
      .proxy,
      .user {
        display: flex;
        flex-direction: column;
        padding: 16px 0;
        .proxy_title,
        .user_title {
          font-size: 16px;
          font-weight: 700;
          color: #333;
          &::before {
            content: '';
            display: inline-block;
            margin-right: 20px;
            width: 40px;
            height: 40px;
            background: url('../../assets/images/d.png') no-repeat;
            vertical-align: middle;
          }
        }
        .proxy_title::before {
          background: url('../../assets/images/d.png') no-repeat;
        }
        .user_title::before {
          background: url('../../assets/images/y.png') no-repeat;
        }
        > ul {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-left: 0;
          font-size: 14px;
          color: #666;
          list-style: none;
          padding: 0;
          > li {
            line-height: 40px;
            &::before {
              content: '';
              display: inline-block;
              margin-right: 10px;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              vertical-align: middle;
            }
            > span {
              margin-left: 1em;
              font-size: 20px;
              vertical-align: middle;
            }
            &:nth-child(1)::before {
              background-color: #fec75a;
            }
            &:nth-child(2)::before {
              background-color: #1dc4b2;
            }
            &:nth-child(3)::before {
              background-color: #7bbcf8;
            }
          }
        }
      }
    }
  }
  .card_device {
    width: 62%;
    .showBox {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding-left: 30px;
      > li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 40px;
        .showBox_title {
          font-size: 16px;
          color: #333;
          vertical-align: middle;
          &::before {
            content: '';
            display: inline-block;
            margin-right: 10px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }
        .line::before {
          background-color: #fec75a;
        }
        .device::before {
          background-color: #1dc4b2;
        }
        .Online::before {
          background-color: #7bbcf8;
        }
        .showBox_total > span {
          color: #8c9fbe;
        }
        > div {
          font-size: 14px;
          color: #666;
          width: 23%;
          > span {
            margin-left: 10px;
            font-size: 20px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

</style>
